import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum FinancialAdviser {
  ARISTOTLE = "ARISTOTLE",
  USER_PREFERRED = "USER_PREFERRED",
  NO_AGENT = "NO_AGENT",
}
interface HealthDeclarationProps {
  height: number | undefined;
  weight: number | undefined;
}

export interface IHealthQuestion {
  questionId: number;
  numOfColumn: number;
  questionPoints: any;
  questionData: string;
  questionDesc: string;
}
export interface Step4State {
  declaration: boolean;
  agentCode: string;
  agentName: string;
  agentSourceOfBusiness: string;
  agentCodeFromUrl: string;
  autoAssignAgent: string;
  heightAndWeight: HealthDeclarationProps;
  isCompleted: boolean;
  uwQuestions: IHealthQuestion[];
  bmi: number;
  agentResponce: any;
  bmiChecked: number;
}

const initialState: Step4State = {
  declaration: false,
  agentCodeFromUrl: "",
  agentCode: "",
  agentName: "",
  agentSourceOfBusiness: "",
  agentResponce: {},
  autoAssignAgent: "",
  heightAndWeight: {
    height: 0,
    weight: 0,
  },
  bmi: 0,
  isCompleted: false,
  uwQuestions: [],
  bmiChecked: 0,
};

const step4Slice = createSlice({
  name: "SHIELD_STARTER_Step4",
  initialState,
  reducers: {
    updateDeclaration: (state, action: PayloadAction<boolean>) => {
      state.declaration = action.payload;
    },
    updateAgentCodeFromUrl: (state, action: PayloadAction<string>) => {
      state.agentCodeFromUrl = action.payload;
    },
    updateAgentCode: (state, action: PayloadAction<string>) => {
      state.agentCode = action.payload;
    },
    updateAgentName: (state, action: PayloadAction<string>) => {
      state.agentName = action.payload;
    },
    updateAgentSourceOfBusiness: (state, action: PayloadAction<string>) => {
      state.agentSourceOfBusiness = action.payload;
    },
    updateAutoAssignAgent: (state, action: PayloadAction<string>) => {
      state.autoAssignAgent = action.payload;
    },
    updateHeightAndWeight: (
      state,
      action: PayloadAction<HealthDeclarationProps>
    ) => {
      state.heightAndWeight = action.payload;
    },
    updateUWQCompleted: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateUWQuestions: (state, action: PayloadAction<IHealthQuestion[]>) => {
      state.uwQuestions = action.payload;
    },
    updateBMI: (state, action: PayloadAction<number>) => {
      state.bmi = action.payload;
    },
    updateAgentResponce: (state, action: PayloadAction<any>) => {
      state.agentResponce = action.payload;
    },
    updateToDefaultStateStep4: (state, action: PayloadAction<string>) => ({
      ...initialState,
    }),
    updateBmiCheckNumber: (state, action: PayloadAction<number>) => {
      state.bmiChecked = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {
  updateDeclaration,
  updateAgentCode,
  updateAgentName,
  updateAutoAssignAgent,
  updateHeightAndWeight,
  updateUWQCompleted,
  updateUWQuestions,
  updateBMI,
  updateAgentResponce,
  updateToDefaultStateStep4,
  updateBmiCheckNumber,
  updateAgentCodeFromUrl,
  updateAgentSourceOfBusiness
} = step4Slice.actions;

export default step4Slice.reducer;
